<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label class="form-group__label" [innerHTML]="question?.question_copy || question?.email_version"></label>
  }

  @if (!editModal) {
    <textarea
      [placeholder]="question?.question_prompt"
      [(ngModel)]="value"
      (ngModelChange)="onChange()"
      [name]="uniqueControlName"
      rows="5"
      class="form-control">
    </textarea>
  }

  @if (editModal) {
    <textarea
      [placeholder]="question?.question_prompt"
      [(ngModel)]="value"
      (blur)="onChange()"
      [name]="uniqueControlName"
      rows="5"
      class="form-control">
    </textarea>
  }
</div>

